// Route wrapper for the per-game showcase page, keeping screens-game.tsx
// free of router coupling (and so directly testable with a plain slug prop,
// the same split every other parameterised screen in this app uses).
import { useParams } from 'react-router-dom';

import { ScreenGame } from './screens-game';

export function ScreenGameRoute() {
  const { slug } = useParams<{ slug: string }>();
  return <ScreenGame slug={slug ?? ''} />;
}
